import _ from 'lodash';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { Button, Col, Row } from 'antd';

import { CopyOutlined } from '@ant-design/icons';
import { RootState } from '../../../../../../application/store';
import { BUSINESS_UNIT_TYPES } from '../../../../../../utils/constants/business-unit-types';
import { ORDER_STATUS } from '../../../../../../utils/constants/order-status';
import { orderTotalByProducts } from '../../../../../../utils/data-format-enchanters/order-products-enchanter';

import './checkout-footer.scss';

import BVOrderQuantityDetails from '../../../../BVOrderQuantityDetails/bv-order-quantity-details';
import BVPasteExcelDialog from '../../../BVBasketDrawer/components/BVPasteExcelDialog/bv-paste-excel-dialog';

interface ICheckoutFooter {
	actionOrderLoading: boolean;
	onComplete: () => void;
	onUpsert: () => void;
}

const CheckoutFooter: React.FunctionComponent<ICheckoutFooter> = ({
	actionOrderLoading,
	onComplete,
	onUpsert,
}) => {
	const bvOrderSummary = useSelector((state: RootState) => state.orderSummary);
	const [open, setOpen] = useState(false);

	return (
		<div className="checkout-footer-container">
			<Row style={{ alignItems: 'center' }}>
				<Col span={8}>
					{bvOrderSummary.products &&
						bvOrderSummary.products.length > 0 &&
						bvOrderSummary.status.code === ORDER_STATUS.DRAFT.code && (
							<React.Fragment>
								<Button
									type="primary"
									icon={<CopyOutlined />}
									onClick={() => setOpen(true)}
									style={{ marginRight: 10 }}
								/>
								<Button
									type="primary"
									disabled={actionOrderLoading}
									size={'middle'}
									style={{ marginRight: 10 }}
									onClick={onUpsert}
								>
									{'Save Draft'}
								</Button>
								<Button
									type="primary"
									disabled={actionOrderLoading}
									size={'middle'}
									onClick={onComplete}
								>
									{'Complete Order'}
								</Button>
								<BVPasteExcelDialog
									visible={open}
									onClose={() => setOpen(false)}
								/>
							</React.Fragment>
						)}
				</Col>
				<Col span={8}>
					<BVOrderQuantityDetails orderProducts={bvOrderSummary.products} />
				</Col>
				<Col span={8} style={{ textAlign: 'right' }}>
					<table style={{ display: 'inline-block' }}>
						<tbody>
							<tr>
								<td colSpan={2}>
									<span className="checkout-footer-order-total">
										{`Total: ${orderTotalByProducts(bvOrderSummary.products).amountFormat}`}
									</span>
								</td>
							</tr>
							<tr>
								<td>
									<span className="checkout-footer-order-partial">
										Jewelry:
									</span>
								</td>
								<td>
									<span className="checkout-footer-order-partial">
										{
											orderTotalByProducts(
												_.filter(
													bvOrderSummary.products,
													(entry) =>
														entry.businessUnitCode ===
														BUSINESS_UNIT_TYPES.JEWELRY_CODE,
												),
											).amountFormat
										}
									</span>
								</td>
							</tr>
							<tr>
								<td>
									<span className="checkout-footer-order-partial">
										Watches:
									</span>
								</td>
								<td>
									<span className="checkout-footer-order-partial">
										{
											orderTotalByProducts(
												_.filter(
													bvOrderSummary.products,
													(entry) =>
														entry.businessUnitCode ===
														BUSINESS_UNIT_TYPES.WATCH_CODE,
												),
											).amountFormat
										}
									</span>
								</td>
							</tr>
						</tbody>
					</table>
				</Col>
			</Row>
		</div>
	);
};

export default CheckoutFooter;
